import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

export const useExternalFormStyles = createUseStyles(
  ({ colors, sizes }: Theme) => ({
    form: {
      '& .container': {
        paddingRight: '0px !important',
        '& .submit-button': {
          display: 'none',
        },
        '& .row': {
          padding: '4px',
          position: 'relative',
          '& label': {
            width: '100%',
            marginBottom: '6px',
          },
          '&:nth-child(1):after, &:nth-child(2):after': {
            fontFamily: 'console-icons !important',
            content: String.raw`"\f24d"`,
            position: 'absolute',
            right: 6,
            top: 30,
            width: 22,
            height: 18,
            backgroundColor: '#fff',
            fontSize: 16,
          },
          '&:nth-child(3) > div': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          },
          '& select, & input[type=password]': {
            width: '100%',
            height: '26px',
            paddingLeft: '10px',
            borderRadius: '6px',
            borderColor: 'rgb(214, 217, 224)',
            backgroundColor: '#fff',
            fontSize: '13px',
            '&:hover, &:focus, &:active, &:focus-visible': {
              borderColor: '#2075D9',
              outline: 'unset',
            },
          },
          '& input[type=password]': {
            borderStyle: 'solid',
            borderWidth: 1,
          },
          '& .file-path': {
            wordBreak: 'break-word',
          },
          '& button.input-group-text': {
            all: 'unset',
            backgroundColor: colors.secondary,
            borderRadius: sizes.button.borderRadius,
            boxSizing: 'border-box',
            color: colors.typoSecondary,
            cursor: 'pointer',
            height: sizes.button.height,
            padding: sizes.button.padding,
            textWrap: 'no-wrap',
            '&:hover, &:focus, &:active': {
              backgroundColor: colors.secondaryHover,
            },
          },
        },
      },
    },
    dropzone: {
      height: 100,
    },
  })
);

export const useLoginWrapperStyles = createUseStyles(
  ({ colors, login, sizes: { dialog } }: Theme) => ({
    '@global': {
      'html, body': { height: '100%' },
      body: login?.body,
      'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
        {
          WebkitTextFillColor: `${colors.typoCommon} !important`,
          transition: 'background-color 5000s ease-in-out 0s',
        },
    },
    wrapper: {
      padding: 32,
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '370px',
      backgroundColor: colors.backgroundGroup,
      color: colors.typoCommon,
      borderRadius: 'var(--radiusBig)',
      boxShadow: dialog.boxShadow ?? 'none',
    },
    userGuideButton: {
      position: 'absolute',
      top: 8,
      right: 8,
    },
  })
);

export const useBaseAuthFormStyles = createUseStyles(({ colors }: Theme) => ({
  form: {
    paddingTop: '10px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '10px',
  },
  logo: {
    flexShrink: 0,
    width: '64px',
    height: '64px',
    borderRadius: '12px',
    backgroundColor: (isDarkMode: boolean) =>
      isDarkMode ? '#FFFFFF' : '#14379F',
    maskSize: 'contain',
    WebkitMaskSize: 'contain',
  },
  logoImg: {
    flexShrink: 0,
    width: '64px',
    height: '64px',
    borderRadius: '12px',
    objectFit: 'contain',
    display: 'block',
  },
  headerText: {
    flex: 1,
  },
  title: {
    composes: 'uppercase',
    fontWeight: 700,
    margin: 0,
  },
  subtitle: {
    margin: 0,
    paddingTop: '8px',
  },
  button: { minWidth: 62 },
  loader: {
    position: 'absolute',
    right: '50%',
    top: '50%',
    color: colors.primary,
    width: 40,
  },
  error: {
    marginBottom: 20,
    color: colors.warning,
    fontWeight: 'bold',
  },
}));
